<template>
  <collapsible-section title="PIM_PRODUCT-ACCORDION_TITLE-DOCUMENTS" :defaultOpen="defaultOpen">

    <!-- GEBRAUCHSANWEISUNGEN -->
    <div class="control">
      <div class="control-label">
        <label-name
          :labelKey="'PIM-PRODUCT-UPLOAD_MANUALS' + labelSuffix"
        ></label-name>
      </div>

      <div class="control">
        <vue-dropzone
          ref="dzPimDocuments"
          id="dzPimDocuments"
          url="fileProcessing/upload?preset=pimProductDocument"
          :formDataAppend="[{ extRef: product.extRef }]"
          :thumbnailWidth="100"
          :thumbnailHeight="100"
          acceptedFiles=".pdf"
          dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Gebrauchsanweisung hochladen"
          v-on:vdropzone-removed-file="dzRemoveFile"
          v-on:vdropzone-success="dzSuccessDocuments"
        >
        </vue-dropzone>
      </div>
    </div>

    <!-- Uploaded Documents -->
    <div
      class="documentsWrapper"
      v-if="product.documents && product.documents.length > 0"
    >
      <div
        v-for="(doc, index) in product.documents"
        class="document"
        :key="doc"
      >
        <a :href="assetGetUrl(doc, false)" download>
          <span class="icon is-small" style="margin-right: 0">
            <i class="icon-ak-datei-pdf"></i>
          </span>

          <span>
            {{ doc.document.uploadFilename }}
          </span>
        </a>

        <pop-confirm
          :content="$t('PIM-PRODUCT-CONFIRMATION-DELETE_DOCUMENT')"
          icon="question-circle-o"
          cancel-text="abbrechen"
          :on-ok="() => documentDelete(index)"
        >
          <span class="delIcon icon is-small" style="cursor: pointer"
            ><i class="fa fa-trash-o"></i
          ></span>
        </pop-confirm>
      </div>
    </div>

  </collapsible-section>
</template>

<script>
import vue2Dropzone from "../../utils/dropzoneWrapper";
import CollapsibleSection from "../../utils/CollapsibleSection.vue";

export default {
  name: "ProductSectionDocuments",

  components: {
    vueDropzone: vue2Dropzone,
    CollapsibleSection,
  },

  props: {
    product: { type: Object, required: true },
    labelSuffix: { type: String, default: "" },
    defaultOpen: { type: Boolean, default: false },
  },

  methods: {
    assetGetUrl(asset, thumb = true) {
      if (!asset) {
        return "";
      }
      if (thumb && asset.thumbUrl && asset.thumbUrl != "") {
        return asset.thumbUrl;
      } else {
        return asset.url;
      }
    },

    dzRemoveFile() {
      // placeholder — dropzone remove handler
    },

    dzSuccessDocuments(file) {
      var result = JSON.parse(file.xhr.response);

      if (typeof this.product.documents == "undefined") {
        this.product.documents = [];
      }

      this.product.documents.push({
        pimProduct_id: this.product.id,
        document: {
          filename: result.fileName,
          path: result.dir,
          uploadFilename: result.uploadFilename,
        },
      });

      this.$refs["dzPimDocuments"].$children[0].removeAllFiles();
    },

    documentDelete(index) {
      this.product.documents.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.documentsWrapper {
  margin: 0 0 20px 0;
  padding: 10px 5px;
  background-color: #f1f1f1;
  font-size: 12px;

  .document {
    position: relative;

    .delIcon {
      position: absolute;
      right: 0;
      margin: 0;
      left: auto;
    }
  }
}
</style>
